import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const OutsideContributor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M4.5 1C3.67157 1 3 1.67157 3 2.5V4C3 4.82843 3.67157 5.5 4.5 5.5H5.5C6.32843 5.5 7 4.82843 7 4V2.5C7 1.67157 6.32843 1 5.5 1H4.5ZM5.5 2.5H4.5V4H5.5V2.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11 15.5C13.4853 15.5 15.5 13.4853 15.5 11C15.5 8.51472 13.4853 6.5 11 6.5C8.51472 6.5 6.5 8.51472 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5ZM9 10H11.293L8.64648 12.6465L9.35359 13.3536L12 10.7072V13H13V9H9V10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M2.25 6.75H7.50869C6.99989 7.16846 6.56756 7.6765 6.2358 8.25H2.5V11H1V8C1 7.30964 1.55964 6.75 2.25 6.75Z"
      fill="currentColor"
    />
  </Icon>
));

export default OutsideContributor;
